import { IonButton, IonButtons, IonFooter, IonIcon, IonTitle, IonToolbar } from "@ionic/react"
import { AuthContext } from "context/auth.context"
import { logOutSharp } from "ionicons/icons"
import React, { useContext } from "react"

const Footer = () => {

    const {isAuth, logout} = useContext(AuthContext);

    return isAuth 
    ? (
      <IonFooter class='ion-no-border'>
        <IonToolbar color='primary'>
          <IonTitle className='ion-text-center'>Copyright © {new Date().getFullYear()} iProcedures LLC. All rights reserved.</IonTitle>
          <IonButtons slot='end'>
            <IonButton onClick={() => { logout() }}>
              <IonIcon slot='icon-only' icon={logOutSharp} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    )
    : <div></div>
}

export default Footer;